import { State } from '../../store/state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectSelectedTreatmentActivityId } from '@ispm-client/modules/process-executor';
import { isEmpty } from 'lodash';
import { selectState } from './pathways-state.selector';

const getClinicalTrials = (state: State): any => state.clinicalTrials;

export const selectClinicalTrials: MemoizedSelector<
  object,
  any
  > = createSelector(selectState, getClinicalTrials);

export const selectChosenClinicalTrials = createSelector([
    selectClinicalTrials,
    selectSelectedTreatmentActivityId],
  (nodes, id) => {
    if (isEmpty(nodes) || !id) {
      return [];
    }
    const clinicalTrials = nodes[id];
    return clinicalTrials;
  });
